import Resource from '../../../api/resource';

export class DanoneService extends Resource {
  constructor() {
    super('danone', '/api', 'api-asman-telkom', null);
  }

  getResultAreaProfiling(param) {
    this.setAdditionUri('/area/result');
    return this.create(param);
  }

  getAhsMarkers(param) {
    this.setAdditionUri('/markers');
    return this.list(param);
  }

  getResultTerritoryPlanning(param) {
    this.setAdditionUri('/territory/result');
    return this.create(param);
  }
  /**
   *
   * @param {object} param
   * @param {string} param.province
   * @param {string} param.city
   */
  downloadSummary(param) {
    this.setAdditionUri('/download/summary');
    return this.list(param);
  }
}
